import React, { useEffect } from "react";
import { injectGmsPartsSearchStyles } from "./gmsPartsSearchStyles";
import { PartsSearch } from "./tailwind/PartsSearch";
import type { PartsSearchProps } from "./tailwind/PartsSearch";

export type GmsPartsSearchProps = PartsSearchProps;

/** GMS Tailwind parts search — injects standalone styles for non-Tailwind hosts (OrCA). */
export function GmsPartsSearch(props: GmsPartsSearchProps) {
  useEffect(() => {
    injectGmsPartsSearchStyles();
  }, []);

  return (
    <div className="garaaz-parts-search-gms">
      <PartsSearch {...props} />
    </div>
  );
}
